import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "as", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { forwardRef } from 'react';
import Box from '../Box';
import { merge } from '../sx';
import { useTheme } from '../ThemeProvider';
import { StyledButton } from './types';
import { getVariantStyles, getSizeStyles, getButtonStyles } from './styles';
var ButtonBase = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'button' : _ref$as,
      _ref$sx = _ref.sx,
      sxProp = _ref$sx === void 0 ? {} : _ref$sx,
      props = _objectWithoutProperties(_ref, _excluded);

  var LeadingIcon = props.leadingIcon,
      TrailingIcon = props.trailingIcon,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size;

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var iconWrapStyles = {
    display: 'inline-block'
  };
  var sxStyles = merge.all([getButtonStyles(theme), getSizeStyles(size, variant, false), getVariantStyles(variant, theme), sxProp]);
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    as: Component,
    sx: sxStyles
  }, props, {
    ref: forwardedRef
  }), LeadingIcon && /*#__PURE__*/React.createElement(Box, {
    as: "span",
    "data-component": "leadingIcon",
    sx: iconWrapStyles
  }, /*#__PURE__*/React.createElement(LeadingIcon, null)), children && /*#__PURE__*/React.createElement("span", {
    "data-component": "text"
  }, children), TrailingIcon && /*#__PURE__*/React.createElement(Box, {
    as: "span",
    "data-component": "trailingIcon",
    sx: _objectSpread(_objectSpread({}, iconWrapStyles), {}, {
      ml: 2
    })
  }, /*#__PURE__*/React.createElement(TrailingIcon, null)));
});
export { ButtonBase };